export const getSelectedTrainReadinessStatus = (
  mandatoryComponentsStatus = {},
) => {
  const {
    columnMapping = {},
    referenceConditions = {},
    defaultCIPInfo = {},
  } = mandatoryComponentsStatus;

  return {
    column_mapping:
      columnMapping.fulfilled && !columnMapping.changed && !columnMapping.error,
    reference_conditions:
      referenceConditions.fulfilled &&
      !referenceConditions.changed &&
      !referenceConditions.error,
    default_cip_information:
      defaultCIPInfo.fulfilled &&
      !defaultCIPInfo.changed &&
      !defaultCIPInfo.error,
  };
};

export const mergeSelectedTrainReadiness = (
  multiTrainStatus = [],
  selectedTrain,
  mandatoryComponentsStatus,
) => {
  const selectedTrainStatus = getSelectedTrainReadinessStatus(
    mandatoryComponentsStatus,
  );

  const trainNumber = Number(selectedTrain);
  const allTrainStatus = Array.isArray(multiTrainStatus)
    ? multiTrainStatus
    : [];
  const mergedStatus = allTrainStatus.map((status) =>
    Number(status.train) === trainNumber
      ? { ...status, ...selectedTrainStatus, train: trainNumber }
      : status,
  );

  if (
    trainNumber &&
    !mergedStatus.some((status) => Number(status.train) === trainNumber)
  ) {
    mergedStatus.push({ train: trainNumber, ...selectedTrainStatus });
  }

  return mergedStatus;
};

export const isTrainReadyForAnalysis = (trainStatus = {}) =>
  Boolean(
    trainStatus.column_mapping &&
    trainStatus.reference_conditions &&
    trainStatus.default_cip_information,
  );
